import React, { useState, useEffect } from 'react';
import {  Typography, Grid, Container, Card, Divider, Button } from '@mui/material';
import styleForm from '../Tool/Style';
import { useStateValue } from '../../Contexto/store';
import DiccionarioEtiquetas from '../../Configuracion/Idiomas/Etiquetas_Diccionario';
import { withRouter } from 'react-router-dom';
import ImgLogin from '../../Activos/Imagenes/LogoClassLimitless.svg';
import { styleLogin } from '../Tool/Style';
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { LlavesConfiguraciones } from "../../Configuracion/Llaves/RepositorioConfig";

const RecuperarContrasenaSatisfactorio = (props) => {
    //se accede al storage para ver la variable de sesion de usuario
    // contexto de variables globales con el Context Api 
    const [{ etiquetasIdioma }] = useStateValue();

    const history = useHistory();

    const location = useLocation();

    // Se declara la variable de estado que representa al idioma para las etiquetas del componente
    const [etiquetas, setEtiquetas] = useState({
        EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
        CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
    });

    useEffect(() => {
        // se llama al dispatch para que como tal se actualice el reducer
        setEtiquetas({
            EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
            CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
        });

    }, [etiquetasIdioma]);

    const regresarPaginaLogin = (e) => {
        e.preventDefault();
        history.push(LlavesConfiguraciones.rutaPublicacion + "/auth/login");
    }

    return (
        <Container maxWidth="sm" justify="center" spacing={0} style={styleLogin.conteiner}>
            <Card style={{ ...styleLogin.divForm, ...{ padding: '3rem' } }}>
                <div style={styleForm.paper}>
                    <img src={ImgLogin} alt={"Imagen de Registro"} />
                    <Typography variant="subtitle2" style={{ fontSize: 16, paddingTop: 25 }}>
                        {etiquetas.EtiquetasComponente.RecuperarContrasenaSatisfactorio.Et_TituloPrincipal}
                    </Typography>
                </div>
                <form style={styleForm.form}>
                    <Grid container spacing={2} style={{ backgroundColor: 'transparent' }}>
                        <Grid item xs={12} >
                            <Typography variant="body1" style={{ fontSize: 16, textAlign: 'justify' }}>
                                {etiquetas.EtiquetasComponente.RecuperarContrasenaSatisfactorio.Et_Cuerpo}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} >
                            <Divider/>
                        </Grid>
                        <Grid item xs={12} >
                            <Typography variant="body" style={{ color: '#1975FF', textAlign: 'justify' }}>
                                {etiquetas.EtiquetasComponente.RecuperarContrasenaSatisfactorio.Et_TxtCorreo}
                            </Typography>
                            <Typography variant="body" style={{ color: '#1975FF', fontWeight: 600 }}>
                                {location.state.email}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} >
                            <Divider />
                        </Grid>
                        <Grid item xs={12} >
                            <Button
                                fullWidth
                                variant="contained"
                                style={styleForm.submit}
                                size="large"
                                onClick={regresarPaginaLogin}>{etiquetas.EtiquetasComponente.RecuperarContrasenaSatisfactorio.Et_BotonRegresar}</Button>
                        </Grid>
                    </Grid>
                </form>
            </Card>
        </Container>
    );
};

export default withRouter(RecuperarContrasenaSatisfactorio);